export default __webpack_public_path__ + "6cd35235b10b8bb003a432941387ab2a.jpg";